<!-- @Version: 1.0.3 --> 
@if (done$$ () == true) {
  <div data-testid="datecontainer" [formGroup]="fgDate" class="row">
    <mat-form-field data-width="100%" [hideRequiredMarker]="hideRequireMaker" >
      @if (fieldItem.attribute_1 && fieldItem.attribute_1 != '') {
        <mat-label data-testid="label" [innerHTML]="fieldItem.attribute_1!"></mat-label>
      }
      <input data-testid="input" [formControlName]="FC_DATE.DATE" [required]="fieldItem.required! && !fgDate.get(FC_DATE.DATE)?.disabled" matInput [matDatepicker]="picker"  [placeholder]="fieldItem.placeholder ?? ''">
      <mat-datepicker-toggle data-testid="datepicker-toggle" matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker data-testid="datepicker" #picker [disabled]="fgDate.get(FC_DATE.DATE)?.disabled" [startView]="dateFormat == DATEFORMATCALENDER.MONTHYEAR || dateFormat == DATEFORMATCALENDER.YEAR ?  DATESTARTVIEW.MULTIYEAR : DATESTARTVIEW.MONTH" (monthSelected)="dateFormat == DATEFORMATCALENDER.MONTHYEAR ? setMonthAndYear($event, picker) : ''" (yearSelected)="dateFormat == DATEFORMATCALENDER.YEAR ? setYear($event, picker) : ''"></mat-datepicker>
      @if (fgDate.get(FC_DATE.DATE)?.hasError(VALIDATORS.datepickerParse)) {
        <mat-error data-testid="errorDatepickerParse" [innerText]="error.errorCodeDateParse"></mat-error>
      }
      @else if (fgDate.get(FC_DATE.DATE)?.hasError(VALIDATORS.future)) {
        <mat-error data-testid="errorOnlyFuture" [innerHTML]="error.errorCodeFuture"></mat-error>
      }
      @else if (fgDate.get(FC_DATE.DATE)?.hasError(VALIDATORS.past)) {
        <mat-error data-testid="errorOnlyPast" [innerHTML]="error.errorCodePast"></mat-error>
      }
      @else if (fgDate.get(FC_DATE.DATE)?.hasError(VALIDATORS.range)) {
        <mat-error data-testid="errorRangeDate" [innerHTML]="error.errorCodeRange"></mat-error>
      }
      @else if (fgDate.get(FC_DATE.DATE)?.hasError(VALIDATORS.relative)) {
        <mat-error data-testid="errorRelativeDate" [innerHTML]="error.errorCodeRelative"></mat-error>
      }
      @else if (fgDate.get(FC_DATE.DATE)?.hasError(VALIDATORS.required) && !fgDate.get(FC_DATE.DATE)?.hasError(VALIDATORS.datepickerParse)) {
        <mat-error data-testid="errorRequired" [innerHTML]="error.errorCodeRequired"></mat-error>
      }
    </mat-form-field>
  </div>
}